import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";
import {ACTIVE} from "../../../../../themes/css-global-classes";
import {FilterLinkIconDefaultPCBox, FilterLinkIconDefaultMobileBox} from "./filter-link-icon.default.box";

const MobileSIBox = styled(FilterLinkIconDefaultMobileBox)`
    background: ${props => props.theme.colors.brandSecondaryDark};
    .${ACTIVE} &{
        background: ${props => props.theme.colors.backgroundLight};
        &:before {
            background-position: -204px -358px;
        }
    }
`;

export const FilterLinkIconMrGreenBox = styledByDevice(FilterLinkIconDefaultPCBox, MobileSIBox);